module.exports = __webpack_public_path__ + "img/ztdybg.65ccb581.png";